import { createToast } from '@/utils'
import { useEffect, useRef, useState } from 'react'
import useTranslate from './use-translate'

export const useNetworkStatus = () => {
  const { t: tCommon } = useTranslate('common')
  const [isOnline, setIsOnline] = useState(navigator.onLine)
  const wasOnline = useRef(navigator.onLine)

  useEffect(() => {
    const handleOnline = () => setIsOnline(true)
    const handleOffline = () => setIsOnline(false)

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  useEffect(() => {
    if (wasOnline.current && !isOnline) {
      createToast('error', tCommon('offline'))
    }

    if (!wasOnline.current && isOnline) {
      createToast('success', tCommon('online'))
    }

    wasOnline.current = isOnline
  }, [isOnline])

  return isOnline
}
